import apiClient from '../api-client';
import type { UserWithoutPassword, LoginResponse } from '@geely/shared';

export const authApi = {
  login: (email: string, password: string) =>
    apiClient.post<LoginResponse>('/auth/login', { email, password }),

  me: () =>
    apiClient.get<UserWithoutPassword>('/auth/me'),
};
